import { helper } from '@ember/component/helper';

import { qpDateRangeIsInverted } from 'rise-ui/utils/qp-date.js';

export default helper(function qpDateInvertedHelper([ dates ]) {
  return qpDateRangeIsInverted(dates);
});
